var t={color:"var(--text-ultrastrong)",minWidth:48},a={maxWidth:116},i={maxWidth:32},x={margin:"-4px -6px",width:"26px",height:"26px"},h={boxSizing:"content-box",maxHeight:28};export{a,i as b,h as c,x as i,t};
